export const formMessages = {
  en: {
    required: 'This field is mandatory, please, provide the required information',
    min: 'The number of characters entered is less than the minimum required for this field.',
    max: 'This field exceeds the maximum number of characters allowed.',
    email: 'The email address format is invalid',
    number: 'This field should only contain numeric characters.',
    max_value: 'The value provided exceeds the maximum allowed for this field',
    min_value: 'The value provided is less than that allowed for this field',
    alpha_spaces: 'This field should only contain alphabetic characters and spaces.',
    unique: 'The value entered in this field must be unique and possibly already being used.',
    confirmed: 'The values provided do not match',
    exist: 'The value indicated in this field is not correct.',
    decimal: 'This field should only contain numbers, decimals are separated by point and without thousands separator.',
    date_format: 'The format of the date indicated in this field is not valid.',
    regex: 'Please check the format of this field, it seems to be invalid',
    rfc: 'The RFC format is incorrect, please validate it.',
    url: 'The URL format is incorrect, please validate it.',
    credit_card: 'The credit card number provided is invalid',
    included: 'Please, select an option',
    match: 'Provided field is incorrect or not valid',
    json: 'El formato de de este valor no es válido, por favor revisar.'
  },
  es: {
    required: 'Es necesario que proporcione este campo',
    min: 'La cantidad de caracteres introducidos es inferior a el mínimo requerido para este campo.',
    max: 'Este campo excede la cantidad máxima de caracteres requeridos.',
    email: 'El formato de la dirección de correo electrónico es invalido.',
    number: 'Este formato solo debe contener caracteres númericos.',
    max_value: 'El valor proporcionado excede el máximo permitido para este campo',
    min_value: 'El valor proporcionado es inferior al permitido para este campo',
    alpha_spaces: 'Este campo solo debe contener caracteres alfabéticos y espacios.',
    unique: 'El valor introducido en este campo debe ser único y posiblemente ya este siendo utilizado.',
    confirmed: 'Los valores proporcionados no coinciden',
    exist: 'El valor indicado en este campo no es correcto.',
    decimal: 'Este campo solo debe contener números, los decimales se separan por punto y sin separador de miles.',
    date_format: 'El formato de la fecha indicada en este campo no es válido.',
    regex: 'Por favor revise el formato de este campo, parece no ser válido',
    rfc: 'El formato del RFC es incorrecto',
    url: 'El formato de la URL es incorrecto.',
    credit_card: 'El número de la tarjeta de crédito no es válido',
    match: 'El valor proporcionado no coincide o no es correcto.',
    json: 'El formato de de este valor no es válido, por favor revisar.'
  }
}



// WEBPACK FOOTER //
// ./src/core/locale/translation/validation/messages.js